<div class="multiselect-filter-container">
	@if (loadingOptions) {
		<div class="loader-container flex-center-center">
			<mat-spinner diameter="40"></mat-spinner>
		</div>
	}
	@if (!loadingOptions) {
		<div class="options-container">
			@if (isLabelFilter()) {
				<div
					class="label-list-menu-template nice-scroll colored-scroll-track visible-scroll"
				>
					<label-list-menu
						(click)="$event.stopPropagation()"
						[selectedLabelPks]="selectedLabelsPks()"
						(selectedLabelsChange)="labelsSelectionChangedHandler($event)"
					/>
				</div>
			}
			<!-- Temporary disable search for categories as they are hardcoded-->
			@if (isSimpleFilter()) {
				@if (
					data.columnName !== 'category' && !nsMultiselectFilterConfig[data.columnName]
				) {
					<au-search-input
						class="m-b-sxs filters-search"
						[placeholder]="'search' | translate"
						(click)="$event.stopPropagation()"
						(searchTextChanged)="searchText$.next($event)"
					></au-search-input>
				}
				<div class="filter-options nice-scroll visible-scroll colored-scroll-track">
					@for (option of filterOptions; track option) {
						<mat-checkbox
							color="primary"
							class="au-checkbox"
							[checked]="isChecked(option)"
							(click)="$event.stopPropagation()"
							(change)="toggleSelection($event, option)"
						>
							{{ option.name | translate }}
						</mat-checkbox>
					}
					@if (!filterOptions.length) {
						<div class="no-results">
							@if ((searchText$ | async).length) {
								<div class="no-data p-l-sm m-t-sxs m-b-sxs">
									{{ 'no_results' | translate }}
								</div>
							} @else {
								<div class="no-data p-l-sm m-t-sxs m-b-sxs">No options available</div>
							}
						</div>
					}
				</div>
			}
		</div>
	}
</div>
